module.exports = __webpack_public_path__ + "static/media/contlabs_white.e314d696.png";